import React, { useEffect, useState } from "react";
import { checkUserUrl } from "../Utils/Utils";

const RcsApiComponent = () => {
  const domain = window.location.protocol + "//" + window.location.host;
  const domain1 = window.location.hostname;

  const [brandName, setBrandName] = useState("");

  useEffect(() => {
    const siteSettings = localStorage.getItem("siteSettings");
    if (siteSettings) {
      const parsed = JSON.parse(siteSettings);
      setBrandName(parsed.brand_name || "");
    }
  }, []);

  const bulkRcsApiUrl = checkUserUrl(domain)
    ? "https://console.authkey.io/restapi/bulkrcs_json.php"
    : `${domain}/restapi/bulkrcs_json.php`;

  return (
    <div className="api-docs">
      <p className="mt-2 mb-0">
        Bulk RCS messaging using {domain1} APIs allows you to send rich,
        template-based RCS messages with optional fallback to SMS or WhatsApp
        for guaranteed delivery.
      </p>

      <h3 className="mt-4">Bulk RCS API</h3>
      <p className="mt-2 mb-0">
        <b>Method:</b> POST
      </p>

      <code>{bulkRcsApiUrl}</code>

      
      <h3 className="mt-5">Bulk RCS – Without Fallback</h3>

      <pre>
        <code>{`
{
  "version": "1.0",
  "authkey": "XXXXXXX",
  "encrpt": "0",
  "template_id": "xxxx_trx_signup_c",
  "country_code": "91",
  "is_unicode": 0,
  "sender": "6Lq1ZLstxQvRnjWA",
  "messages": [
    {
      "dest": ["920191xxxx"],
      "param": {
        "name": "name",
        "company": "company"
      }
    }
  ]
}
        `}</code>
      </pre>

      <h3 className="mt-5">Bulk RCS – With Fallback (fb1)</h3>

      <pre>
        <code>{`
{
  "version": "1.0",
  "authkey": "XXXXXXX",
  "encrpt": "0",
  "template_id": "xxxx_trx_signup_c",
  "country_code": "91",
  "is_unicode": 0,
  "sender": "6Lq1ZLstxQvRnjWA",
  "is_fallback": 1,
  "fallback_condition": {
    "fb1": {
      "channel": "sms",
      "condition": ["failed"],
      "id": "xxxx",
      "data": {
        "otp": "name",
        "company": "company"
      },
      "is_dynamic": 1
    }
  },
  "messages": [
    {
      "dest": ["920191xxxx"],
      "param": {
        "name": "name",
        "company": "company"
      }
    }
  ]
}
        `}</code>
      </pre>

      <h3 className="mt-5">Bulk RCS – With Multiple Fallback (fb1 + fb2)</h3>

      <pre>
        <code>{`
{
  "version": "1.0",
  "authkey": "XXXXXX",
  "encrpt": 0,
  "template_id": "pdftest",
  "country_code": "91",
  "is_unicode": "0",
  "is_fallback": 1,
  "fallback_condition": {
    "fb1": {
      "channel": "whatsapp",
      "condition": ["failed"],
      "id": "xxxx",
      "data": {
        "1": "var3"
      },
      "is_dynamic": 1
    },
    "fb2": {
      "channel": "sms",
      "condition": ["failed"],
      "id": "xxxx",
      "data": {
        "otp": "var3"
      },
      "is_dynamic": 1
    }
  },
  "sender": "691c3b8666b27821b2eaxxxx",
  "messages": [
    {
      "dest": ["901593xxxx"],
      "param": {
        "var1": "",
        "var2": "",
        "var3": "",
        "fileUrl1": "https://xxxxxxxxxxxxxxxxxxxxxx.pdf"
      }
    }
  ]
}
        `}</code>
      </pre>

      
      <h3 className="mt-5">Success Response</h3>

      <pre>
        <code>{`
{
  "status": "Success",
  "code": 200,
  "LogID": "65107179571a1e06f50026edd2c3xxxx",
  "Message": "Submitted Successfully"
}
        `}</code>
      </pre>

      
      <h3 className="mt-5">Failure Responses</h3>

      <pre>
        <code>{`
{
  "status": "failure",
  "code": 455,
  "desc": "sender or template_id not passed",
  "ts": "2026-02-04 16:37:25"
}
        `}</code>
      </pre>

      <pre>
        <code>{`
{
  "status": "failure",
  "code": 401,
  "desc": "No authkey",
  "ts": "2026-02-04 16:38:06"
}
        `}</code>
      </pre>

      <pre>
        <code>{`
{
  "status": "failure",
  "code": 400,
  "Message": "Invalid authkey or insufficient balance"
}
        `}</code>
      </pre>

      <pre>
        <code>{`
{
  "status": "failure",
  "code": 425,
  "desc": "No country_code",
  "ts": "2026-02-04 16:38:56"
}
        `}</code>
      </pre>

      <pre>
        <code>{`
{
  "status": "failure",
  "code": 425,
  "desc": "No sender",
  "ts": "2026-02-04 16:39:11"
}
        `}</code>
      </pre>

      
      <h4 className="my-4 text-muted">
        <b>Parameters:</b>
      </h4>

      <p>
        <pre className="preinline">&lt;Your authkey&gt;</pre> = Your {brandName} portal authkey
      </p>
      <p>template_id = RCS Template name</p>
      <p>sender = RCS Sender / Bot ID</p>
      <p>messages.dest = Destination mobile number(s) without country code</p>
      <p>messages.param = Template parameters</p>
      <p>is_fallback = 1 to enable and 0 to disable fallback</p>
      <p>fallback_condition = Fallback channel configuration</p>

      <p className="mt-4 text-muted">
        <b>Note:</b> All values shown in the above examples are for demonstration
        purposes only. You must replace them with your own valid authkey,
        template_id, sender ID, mobile numbers, and parameter values before
        making actual API requests.
      </p>
    </div>
  );
};

export default RcsApiComponent;
